import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9d59538"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page_info" }
const _hoisted_3 = { class: "page_info_title" }
const _hoisted_4 = { class: "page_info_nr" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "物料信息：", -1))
const _hoisted_7 = {
  key: 0,
  class: "item_nr"
}
const _hoisted_8 = {
  class: "items",
  style: {"margin-top":"0"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "生产数量：", -1))
const _hoisted_10 = {
  key: 0,
  class: "item_nr"
}
const _hoisted_11 = { class: "item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "生产批次：", -1))
const _hoisted_13 = { class: "item_nr" }
const _hoisted_14 = { class: "items" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "生产工序：", -1))
const _hoisted_16 = {
  key: 0,
  class: "item_nr"
}
const _hoisted_17 = { class: "item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "工单编号：", -1))
const _hoisted_19 = { class: "item_nr" }
const _hoisted_20 = { class: "items" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "生产设备：", -1))
const _hoisted_22 = {
  key: 0,
  class: "item_nr"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_title" }, "检验信息", -1))
const _hoisted_24 = { class: "page_info1" }
const _hoisted_25 = {
  class: "page_info1_item",
  style: {"margin":"0"}
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "检验人员：", -1))
const _hoisted_27 = { class: "nr" }
const _hoisted_28 = { class: "page_info1_items" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "检验日期：", -1))
const _hoisted_30 = { class: "nr" }
const _hoisted_31 = { class: "page_info1_item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "合格数量：", -1))
const _hoisted_33 = {
  key: 0,
  class: "nr"
}
const _hoisted_34 = { class: "page_info1_items" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "不良数量：", -1))
const _hoisted_36 = {
  key: 0,
  class: "nr"
}
const _hoisted_37 = {
  key: 0,
  class: "page_err"
}
const _hoisted_38 = { class: "page_err_items" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "不良原因：", -1))
const _hoisted_40 = {
  key: 1,
  class: "page_footer"
}

import { ref, onMounted } from 'vue'
    import { useStore } from 'vuex'
    import { useRoute, useRouter } from "vue-router"
    import { getBYid } from '@/apis/QualityAPI'
    import { deletejy } from "@/apis/PlanningAPI"
    import { Toast } from 'vant'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const route = useRoute()
    const store = useStore()
    const router = useRouter()

    let info: any = ref({})

    const getBYids = () => {
        getBYid(route.query.id)
            .then(res => {
                if (res.code === 200 && res.data) {
                    info.value = res.data
                }
            })
    }

    // 删除检验记录
    const dele = (): void => {
        deletejy(route.query.id)
            .then(res => {
                if (res.code === 200) {
                    Toast.success({ message: '删除成功', forbidClick: true, duration: 2000 })
                    setTimeout(() => {
                        router.go(-1)
                    }, 2000)
                }
            })
    }

    onMounted(() => {
        getBYids()
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(info).code), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          (_unref(info).mmodel)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(info).mmodel.name) + "丨" + _toDisplayString(_unref(info).mmodel.code), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          (_unref(info).umodel)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(info).num) + _toDisplayString(_unref(info).umodel.name), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(info).batch), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          (_unref(info).pmodel)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(info).pmodel.name), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(info).workorderCode), 1)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          (_unref(info).devmodel)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_unref(info).devmodel.name), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _hoisted_23,
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _hoisted_26,
        _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(info).smodelRealName) + "/" + _toDisplayString(_unref(info).checkUserDepartName), 1)
      ]),
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(info).checkDate), 1)
      ]),
      _createElementVNode("div", _hoisted_31, [
        _hoisted_32,
        (_unref(info).umodel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_unref(info).qualifiedNum) + _toDisplayString(_unref(info).umodel.name), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_34, [
        _hoisted_35,
        (_unref(info).umodel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_unref(info).unqualifiedNum) + _toDisplayString(_unref(info).umodel.name), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (_unref(info).checkInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("span", null, _toDisplayString(_unref(info).checkInfo), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(info).createUser === _unref(store).state.userInfo.id && _unref(info).workorderstatus !== 4 && _unref(info).workorderstatus !== 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
          _createElementVNode("div", {
            class: "page_footer_dele red",
            onClick: dele
          }, "删除")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})